<template>
    <div>
        <el-row>
            <el-col :span="16" :offset="4">
                <div v-if="newTemp" class="bg new-temp" id="printBox">
                    <h2 class="title"></h2>
                    <p class="cert-no"><span class="label" style="font-size: 18px;">证书编号：</span><span class="text"> {{ certStr }}</span></p>
                    <div class="content">
                        <el-upload
                            class="avatar-uploader"
                            :data="upToken"
                            :action="action"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="/" />
                            <div v-else class="avatar-upload">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                                <p>上传头像</p>
                            </div>
                        </el-upload>
                        <div class="cert-text">
                            <div style="transform: translate(20px, 16px); line-height: 40px;">
                                <span class="text">  {{ userName }} </span>
                                <span class="label">同志，</span>
       
                                <span class="label" style="margin-left: 10px">身份证号：</span>
                                <span class="text">  {{ userInfo.cardId }} </span>
                                <span class="label">，</span>
                                <span class="label"  style="margin-left: 10px">参加</span>
                                <span class="text">  {{ className }}</span> 
                                <span class="label">，</span>
                                <span class="label">修满教学计划规定的18小时课程，计30学时，准予结业。授证时间 </span>
                                <span class="text"> {{ certTime }}</span>
                                <span class="label"> 。</span><br/><br/>
                                <span class="label" style="margin-left: 65px">特发此证。</span>

                            </div>
                            <!-- </div> -->
                            <!-- <div style="transform: translate(24px, 80px)">{{ certTime }}</div> -->
                        </div>
                    </div>
                    <div class="foot">
                        <div class="foot-sponsor">
                            <div v-for="(item, index) in sponsorList" :key="index" class="foot-sponsor-item">
                                <div class="foot-sponsor-text">
                                    {{ item.sponsorName }}
                                </div>
                                <div class="foot-sponsor-img">
                                    <img :src="item.sponsorUrl" />
                                </div>
                            </div>
                            <div class="foot-time">
                                <p>{{ nowtime }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg" id="printBox" v-else>
                    <h2 class="title">结业证书</h2>
                    <p class="cert-no">{{ certStr }}</p>
                    <div class="content">
                        <el-upload
                            style="margin-left: 70px"
                            class="avatar-uploader"
                            :data="upToken"
                            :action="action"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="/" />
                            <div v-else class="avatar-upload">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                                <p>上传头像</p>
                            </div>
                        </el-upload>
                        <div class="cert-text">
                            <p>
                                {{ userName }}
                                <span v-if="ifID">，身份证号：{{ userInfo.cardId }}，</span>
                                于{{ startTime }}至{{ endTime }}参加{{ className }}，修满教学计划规定的课程，计{{
                                    classHours
                                }}学时，
                                <span v-if="isPaper">测试成绩为{{ score }}，达到{{ level }}等次，</span>
                                准予结业。授证时间{{ certTime
                                }}<span v-if="signTime">，培训证有效期至{{ expiryTime }}</span
                                >。
                            </p>
                        </div>
                    </div>
                    <div class="foot">
                        <div class="foot-sponsor">
                            <div v-for="(item, index) in sponsorList" :key="index" class="foot-sponsor-item">
                                <div class="foot-sponsor-text">
                                    {{ item.sponsorName }}
                                </div>
                                <div class="foot-sponsor-img">
                                    <!-- <img src="../../assets/image/zzs.png" /> -->
                                    <img :src="item.sponsorUrl" />
                                </div>
                            </div>
                            <div class="foot-time">
                                <p>{{ nowtime }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="16" :offset="4">
                <div class="text-center" @click="checkAvator">
                    <el-button class="btn-print" plain v-print="'#printBox'" :disabled="imageUrl == ''"
                        >打印合格证</el-button
                    >
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import api from '../../api'
import cookie from '@/api/cookie'
import * as moment from 'moment'
// import CourseSelectModalVue from '../../../../back/src/views/course/modules/CourseSelectModal.vue';

export default {
    name: 'certificate',
    data() {
        return {
            statusId: '',
            imageUrl: '',
            domain: '',
            upToken: {},
            userName: '',
            userFree: false,
            className: '',
            startTime: '',
            endTime: '',
            classHours: '',
            sponsorList: {},
            classConfigId: '',
            userStr: '',
            certStr: '',
            endYear: '',
            certTime: '',
            expiryTime: '',
            nowtime: '',
            signTime: null,
            isPaper: false,
            score: 0,
            level: '合格',
            userInfo: {},
            ifID: false,
            newTemp: false,
        }
    },
    computed: {
        action() {
            return api.action
        },
    },
    methods: {
        checkAvator() {
            if (this.imageUrl == '') {
                this.$message.error('请先上传真实照片')
            }
        },
        timestampToTime(timestamp) {
            let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = date.getFullYear() + '年'
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
            return Y + M
        },
        timestampToString(dateTime) {
            let date = new Date(dateTime)
            let y = date.getFullYear().toString()
            let m = date.getMonth() + 1
            let str = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
            var yearStr = ''
            for (var i = 0; i < y.length; i++) {
                yearStr += str[y[i]]
            }
            return yearStr + '年' + str[m] + '月'
        },
        // eslint-disable-next-line no-unused-vars
        handleAvatarSuccess(res, file) {
            this.imageUrl = this.domain + res.key
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isJPG) {
            //     this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            // if (!isLt2M) {
            //     this.$message.error('上传头像图片大小不能超过 2MB!');
            // }
            // return isJPG;
        },
        init() {
            // 202210 证书加上级别
            if (
                this.classConfigId == 34 ||
                this.classConfigId == 35 ||
                this.classConfigId == 41 ||
                this.classConfigId == 48
            ) {
                this.isPaper = true
            }
            // 202208,新增的培训都需要加上身份证
            if (this.classConfigId > 37) {
                this.ifID = true
            }
            api.getToken().then((res) => {
                this.domain = res.data.domain + '/'
                this.upToken.token = res.data.upToken
            })
            api.getUserInfo(cookie.getCookie('userId')).then((res) => {
                // console.log(res.data)
                // console.log(this.$route.query.classId)
                this.userName = res.data.userName
                this.userInfo = res.data
                if (res.data.userType == 3) {
                    this.$alert('没有打印权限', '提示', {
                        confirmButtonText: '确定',
                        callback: (action) => {
                            this.$router.go(-1)
                        },
                    })
                    this.userFree = true
                } else if (!this.userName) {
                    this.$alert('请先进行实名认证', '提示', {
                        confirmButtonText: '确定',
                        callback: (action) => {
                            this.$router.push('/auth')
                        },
                    })
                }
                // console.log(res.data.userId.toString().length)
                // console.log(this.userStr)
            })
            // api.getClassHistory(cookie.getCookie('userId')).then(res=>{
            // console.log(res.data)
            // this.classConfigId=res.data[0].classConfigId
            // this.classHours=res.data[0].totalHours
            // this.className=res.data[0].className
            // this.startTime=this.timestampToTime(res.data[0].studyStartTime)
            // this.endTime=this.timestampToTime(res.data[0].studyEndTime)
            // this.nowtime=this.timestampToString(res.data[0].studyEndTime)
            api.getClassConfig(this.classConfigId).then((res) => {
                console.log(res)
                // console.log(this.userStr)
                this.classHours = res.data.bxHours + res.data.xxHours
                this.className = res.data.className
                this.startTime = moment(res.data.studyStartTime).format('YYYY年MM月DD日')
                this.endTime = moment(res.data.studyEndTime).format('YYYY年MM月DD日')
                // this.nowtime = this.timestampToString(res.data.studyEndTime);
                let len = cookie.getCookie('userId').length
                let userId = cookie.getCookie('userId')
                switch (len) {
                    case 1:
                        this.userStr = '0000' + userId
                        break
                    case 2:
                        this.userStr = '000' + userId
                        break
                    case 3:
                        this.userStr = '00' + userId
                        break
                    case 4:
                        this.userStr = '0' + userId
                        break
                    case 5:
                        this.userStr = userId.toString()
                        break
                    default:
                        this.userStr = userId
                        break
                }
                this.signTime = res.data.signTime
                if (res.data.signTime) {
                    this.expiryTime = this.timestampToString(res.data.signTime)
                }
                let year = res.data.needPaper ? res.data.years : moment(res.data.certStartTime).format('YYYY')
                this.certStr = year + res.data.prefix + this.userStr
                // this.endYear = (res.data.years && parseInt(res.data.years)) + 3;
                if (res.data.needPaper) {
                    api.getTestHistory(this.statusId).then((res) => {
                        console.log('getTestHistory', res)
                        this.certTime = moment(res.data.time).format('YYYY年MM月DD日')
                        this.nowtime = this.timestampToString(res.data.time)
                        this.score = res.data.score
                        this.level = res.data.score >= 90 ? '优秀' : '合格'
                    })
                } else {
                    console.log(res.data.certStartTime)
                    var date = +new Date()
                    this.certTime = moment(res.data.certStartTime).format('YYYY年MM月DD日')
                    this.nowtime = this.timestampToString(date)
                }
            })
            // }
            // )
            api.getSponsor(this.classConfigId).then((res) => {
                // console.log(res.data.list)
                this.sponsorList = res.data.list
            })
        },
    },
    created() {
        this.classConfigId = this.$route.query.classId
        const ids = [55, 63,64,65,66,67,68,69]

        this.newTemp = ids.includes(Number(this.classConfigId))
        // this.newTemp = true
        this.statusId = this.$route.query.statusId
        this.init()
    },
}
</script>

<style scoped lang="scss">
@media print {
    #printBox {
        background: url('http://guopei-jxjy.hcinfos.cn/front/static/zsbg.png') no-repeat;
        background-size: 100% 100%;
    }
    #printBox.new-temp {
        background: url('~@/assets/image/blank-temp.jpg') no-repeat;
        background-size: contain;
        background-position-y: 0px;
        background-position-x: 0px;
        .avatar{
            transform: translateY(-21px)
        }

    }
}

.bg {
    background: url('http://guopei-jxjy.hcinfos.cn/front/static/zsbg.png') no-repeat;
    background-size: 100% 100%;
    height: 700px;
    width: 900px;
    margin: 30px auto;
    display: flex;
    flex-direction: column;
    position: relative;
    font-family: serif;
}
.new-temp {
    background: url('~@/assets/image/zsbg1.jpg') no-repeat 100% 100%;
    background: url('~@/assets/image/blank-temp.jpg') no-repeat 100% 100%;
    background-size: contain;
    .title {
        margin-bottom: 70px;
    }
    .avatar-uploader {
        margin-left: 104px;
        margin-top: -9px;
        .avatar-upload {
            border: none;
            height: 119px;
        }
        .avatar {
            width: 85px;
            height: 120px;
            margin: 5px 0;
        }
    }
    .label{
        color: #000;
        font-weight: bold;
    }
    .text{
        text-decoration: underline;
    }

    .cert-no {
        margin: 0;
        text-align: center;
        font-size: 24px;
        transform: translate(0px, -27px);
    }
    .cert-text {
        margin-right: 117px;
        padding: 0px 10px;
        transform: translateY(-27px);
        width: 604px;
        > div,
        > span {
            font-size: 18px;
        }
        > div {
            display: inline-block;
        }
    }
    .foot {
        font-size: 18px;
        transform: translate(-39px, 13px);
    }
}
.title {
    text-align: center;
    margin-top: 145px;
    font-size: 56px;
    line-height: 90px;
    height: 75px;
    color: #cc0009;
}

.content {
    display: flex;
    justify-content: space-between;
}

.cert-no {
    margin: 0;
    text-align: center;
    font-size: 24px;
    /* transform: translate(25px, -9px); */
}

.cert-text {
    margin-right: 80px;
    padding: 0 20px;
}

.cert-text p {
    margin: 10px 0;
    font-size: 20px;
    line-height: 40px;
    text-indent: 2em;
}

.foot {
    margin: 0 100px;
}

.foot:after {
    content: ' ';
    clear: both;
}

.foot-sponsor {
    float: right;
}

.foot-sponsor-item {
    display: inline-block;
    margin-left: 10px;
    position: relative;
}

.foot-sponsor-img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.foot-sponsor-img img {
    display: block;
    max-width: 120px;
}

.foot-sponsor-text {
    white-space: nowrap;
}

.zg {
    margin-left: 20px;
}

.foot-time {
    clear: both;
    text-align: center;
}
.el-upload .el-upload--text {
    margin-left: 46px;
}
.el-upload {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-left: 100px;
    margin-top: 20px;
}

.avatar-upload {
    border: 2px solid #ccc;
}

.avatar-uploader .el-upload:hover {
    border-color: #cc0009;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 84px;
    height: 84px;
    line-height: 116px;
    text-align: center;
}

.avatar {
    width: 107px;
    height: 137px;
    display: block;
    margin-top: 45px;
}

.text-center {
    text-align: center;
}

.btn-print {
    background: linear-gradient(to top, #ca000f, #ea000d);
    color: white;
    margin-top: 20px;
    width: 200px;
}
</style>
